export function gameModeScrollTarget({ contextChanged, feedScrollTop, hasPersistentPlayer, mode, playerHeight, previousMode, }) {
    if (contextChanged) {
        return 0;
    }
    if (mode === previousMode) {
        return null;
    }
    if (mode === "feed") {
        return feedScrollTop;
    }
    return hasPersistentPlayer &&
        playerHeight > 0 &&
        feedScrollTop >= playerHeight
        ? playerHeight
        : 0;
}
